import { render } from "./DraggableWarp.vue?vue&type=template&id=06e4b5c0"
import script from "./DraggableWarp.vue?vue&type=script&lang=js"
export * from "./DraggableWarp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__